import { render, staticRenderFns } from "./BodyguardPriceList.vue?vue&type=template&id=6cd445eb&"
import script from "./BodyguardPriceList.vue?vue&type=script&lang=js&"
export * from "./BodyguardPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports